module.exports = __webpack_public_path__ + "static/media/13_digginglight.88f2b81b.jpg";